if (window.__crossBorderNewLoaded) {
} else {
  window.__crossBorderNewLoaded = true;

document.addEventListener('DOMContentLoaded', function () {
  const searchParams = new URLSearchParams(window.location.search);

  let partner = searchParams.get('partner') || getPartnerDetailsFromLocalStorage()?.partner;

  if (partner) {
    const links = document.querySelectorAll('.countries_list_url, .countries_list_languages_url');

    links.forEach(link => {
      var urlX = $(link).attr('v-href');
      if(urlX !=undefined){
          const url = new URL(urlX);
          url.searchParams.set('partner', partner);
         $(link).attr('v-href',url.toString());
      }

    });
  }

});

// Tab navigation locking functionality
let lastFocusedElement = null;
let focusableElements = null;

// Focusable elements are provided by focus-utils.js; degrade gracefully if it failed to load.
const getFocusableElements = (container) => window.JPFocusUtils ? window.JPFocusUtils.getFocusableElements(container) : [];

function trapFocus(event, container) {
  if (!container) return;

  if (!focusableElements) {
    focusableElements = getFocusableElements(container);
  }
  
  if (focusableElements.length === 0) return;
  
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  
  if (event.key === 'Tab') {
    if (event.shiftKey) {
      // Shift + Tab: move backwards
      if (document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }
    } else {
      // Tab: move forwards
      if (document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  }
}

function openModal() {
  const modal = document.getElementById('modal_country_lists');
  if (!modal) return;
  
  // Store the currently focused element
  lastFocusedElement = document.activeElement;
  
  // Show the modal
  modal.style.display = 'block';
  
  // Reset focusable elements cache
  focusableElements = null;
  
  // Add event listeners for focus trapping
  modal.addEventListener('keydown', (event) => trapFocus(event, modal));
  
  // Add escape key handler
  const handleEscape = (event) => {
    if (event.key === 'Escape') {
      closeCountryListModal();
    }
  };
  document.addEventListener('keydown', handleEscape);
  
  // Store the escape handler for cleanup
  modal._escapeHandler = handleEscape;
  
  // Use MutationObserver to wait for focusable elements to be available
  const observer = new MutationObserver((mutations) => {
    const focusableElementsList = getFocusableElements(modal);
    if (focusableElementsList.length > 0) {
      focusableElementsList[0].focus();
      observer.disconnect(); // Stop observing once we've focused
    }
  });
  
  // Start observing the modal for DOM changes
  observer.observe(modal, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden', 'style', 'class']
  });
  
  // Store the observer for cleanup
  modal._focusObserver = observer;
  
  // Also try to focus immediately in case elements are already present
  const focusableElementsList = getFocusableElements(modal);
  if (focusableElementsList.length > 0) {
    focusableElementsList[0].focus();
    observer.disconnect();
  }
}

function closeCountryListModal() {
  const modal = document.getElementById('modal_country_lists');
  if (!modal) return;
  
  // Hide the modal
  modal.style.display = 'none';
  
  // Remove event listeners
  modal.removeEventListener('keydown', (event) => trapFocus(event, modal));
  
  // Remove escape key handler
  if (modal._escapeHandler) {
    document.removeEventListener('keydown', modal._escapeHandler);
    delete modal._escapeHandler;
  }
  
  // Disconnect the focus observer
  if (modal._focusObserver) {
    modal._focusObserver.disconnect();
    delete modal._focusObserver;
  }
  
  // Restore focus to the last focused element
  if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
    lastFocusedElement.focus();
  }
  
  // Clear the cache
  focusableElements = null;
  lastFocusedElement = null;
}

$(document).ready(function() {
  var currentSectionId = "{{ section.id }}";
  function shouldRunActions() {
   return $(window).width() <= 766;
 }

 $(`.button_id`).click(function() {
   openModal();
   $("#cntry_button1").removeAttr("hidden"); // Perform additional actions as needed
   if (shouldRunActions()) {
     if (!$('body').hasClass('cart-store-switch-modal-open')) {
       $('.mobile_hidden_list').css('display', 'block');
     }
    }
 });


 $(`.close_modal`).click(function() {
   closeCountryListModal();
   if (shouldRunActions()) {
     $('.mobile_hidden_list').css('display', 'none'); // Using CSS method for consistency in jQuery
   }
 });

  const { origin, pathname } = window.location;
  let path = (pathname.match(/^\/[a-z]{2}(\/|$)/)?.[0] || '')
  if(path.endsWith('/')) {
    path = path.slice(0, path.length - 1)
  }
  const baseUrlWithLang = origin + path;

  console.log('baseUrlWithLang', baseUrlWithLang);
  setActiveState(baseUrlWithLang);
});

function setCurrentCountryLanguage()
{


 const flagIconClass = localStorage.getItem('flagIconClass');
 const storedCountry = localStorage.getItem('selectedCountry');
 const storedLanguage = localStorage.getItem('selectedLanguage');
 const storedHref = localStorage.getItem('selectedLinkHref');
 const lists = document.querySelectorAll('.custom_country_selected_list');
 lists.forEach(list => {
     list.innerHTML = `${storedLanguage} | ${storedCountry} <span class="flag-icon flag-icon-${flagIconClass}"></span>`;
   });
 $(`a[v-href="${storedHref}"]`).parents('li').addClass('active');
 $(`.countries_list_country-languages a[v-href="${storedHref}"]`).addClass('active');
}


document.addEventListener("DOMContentLoaded", function() {
var buttons = document.getElementsByClassName('button_id');
Array.from(buttons).forEach(function(button) {
 button.addEventListener('click', function() {
   openModal();
 });
});
});


const closeModalEl = document.getElementById('closeModal_country_lists');
if (closeModalEl) {
  closeModalEl.addEventListener('click', function () {
    closeCountryListModal();
  });
}
function setCountryAndLanguage(countryCode, languageCode) {
 window.location.href = `https://${countryCode}.juiceplus.com/${languageCode}`;
}

function setActiveState(link)
{
  console.log(" setActiveState function is running");
  console.log('setActiveState link', link);
  document.querySelectorAll('.countries_list_country-languages a.active').forEach(activeLink =>
  {
      activeLink.classList.remove('active');
      activeLink.closest('.countries_list_country-item').classList.remove('active');
  });
  $('[data-js-href="'+link+'"]').addClass('active');
  $('[data-js-href="'+link+'"]').parents('.countries_list_country-item').addClass('active');
  const flagIconClass =$('[data-js-href="'+link+'"]').parents('.countries_list_country-name').find('span.flag-icon').attr('class') || 'flagIconClass flag-icon flag-icon-usa';
  const countryName = $('[data-js-href="'+link+'"]').parents('.countries_list_country-name').find('.countries_list_url').text() || 'United States';
  const languageName = $('[data-js-href="'+link+'"].countries_list_languages_url').text() || 'English';

  localStorage.setItem('flagIconClass', flagIconClass);
  localStorage.setItem('selectedCountry', countryName);
  localStorage.setItem('selectedLanguage', languageName);
  localStorage.setItem('selectedLinkHref', link);

const lists = document.querySelectorAll('.custom_country_selected_list');
lists.forEach(list => {
   list.innerHTML = `${languageName} | ${countryName} <span class="flag-icon flag-icon-${flagIconClass}"></span>`;
 });
}
function normalizeUrl(url)
{
  const parsedUrl = new URL(url);
  let path = parsedUrl.pathname === '/' ? '' : parsedUrl.pathname;
  if (path === '/en' || path === '') {
      path = '';
  }

  return parsedUrl.origin + path;
}

function pushGa4CustomEvent(eventName, eventData) {
  window.dataLayer = window.dataLayer || [];
  const payload = { event: eventName, ...eventData };
  window.dataLayer.push(payload);

  const css1 = 'background: red; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;';
  const css2 = 'background-color: blue; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;';
  console.log('%cGTM DataLayer Event:%c' + eventName, css1, css2, payload);
}

function clearCart() {
    const partnerInfo = localStorage.getItem('partnerInfo');
    let partner = null;
    if (partnerInfo) {
      try {
        const parsedInfo = JSON.parse(partnerInfo);
        partner = parsedInfo.commSysPartnerID || null;
      } catch (e) {
        console.error('Failed to parse partnerInfo:', e);
      }
    }
  // Clear the cart, then redirect to the account page.
  (window.JPCartService
    ? window.JPCartService.clear()
    : fetch('/cart/clear.js', { method: 'POST' }).then(response => {
        if (!response.ok) throw new Error('clear failed');
        return response;
      }))
  .then(() => {
     var to_link = localStorage.getItem('selectedLinkHref');
      const accountUrl = new URL(to_link + '/account');
      if (partner) {
        accountUrl.searchParams.set('partner', partner);
      }
      window.location.href = accountUrl.toString();
  })
  .catch(error => {
    console.error('Failed to clear the cart:', error);
  });
}

// selected country active code
document.addEventListener("DOMContentLoaded", function() {

var isCartEmpty = null;
//cart is empty or not function
function checkIfCartIsEmpty() {
  (window.JPCartService ? window.JPCartService.getCart() : fetch('/cart.js').then(response => response.json()))
    .then(cart => {
      if (cart.item_count === 0) {
        isCartEmpty = 'true'
        console.log('The cart is empty.', isCartEmpty);
        // Perform actions when the cart is empty
      } else {
         isCartEmpty = 'false'
        console.log('The cart has ' + cart.item_count + ' items.', isCartEmpty);
        // Perform actions when the cart is not empty
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Using the class name to attach event listeners
var buttons = document.getElementsByClassName('button_id');
Array.from(buttons).forEach(function(button) {
 button.addEventListener('click', function() {
  console.log("button_id click");
  checkIfCartIsEmpty(); console.log("checkIfCartIsEmpty inner button id");
   openModal();
 });
});


 var isLoggedInElement = document.querySelector('.countries_list_modal-content');
 if (isLoggedInElement) {
   var isLoggedIn = isLoggedInElement.getAttribute('data-logged-in');    // customer account is loggedin get here
   console.log("Is user logged in?", isLoggedIn);

     if (isCartEmpty == 'true') {
          console.log("Cart is currently empty if isCartEmpty inner.");
     } else {   console.log("There are items in the cart if isCartEmpty inner.");  }
 } else {
   console.log("Element with class '.countries_list_modal-content' not found.");
 }

 const isCartPagePath = () => {
   const pathname = window.location.pathname || '';
   return /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart(?:\/|$)/.test(pathname);
 };

 const isDifferentMarketHost = (href) => {
   if (!href) return false;
   try {
     const targetUrl = new URL(href, window.location.origin);
     return targetUrl.host !== window.location.host;
   } catch (e) {
     return false;
   }
 };

 const maybeOpenCartMarketRedirectModal = (linkHref) => {
   if (!isCartPagePath() || !isDifferentMarketHost(linkHref)) return false;
   if (typeof window.openCartStoreSwitchConfirmModal !== 'function') return false;
   if (typeof window.closeCountryListModal === 'function') {
     window.closeCountryListModal();
   }
   window.openCartStoreSwitchConfirmModal(linkHref);
   return true;
 };

 $(document).on("click",".countries_list_url",function() {
   // Set ManualCountryChange cookie for 1 minute with correct domain
   //const cookieDomain = location.hostname.includes('dev')
   //  ? '.dev.juiceplus.com'
   //  : '.juiceplus.com';
  // document.cookie = `ManualCountryChange=True; max-age=60; path=/; domain=${cookieDomain}; secure`;
   // skip the click event if the data-href attribute is not present (temporary Israel specific case)
   if ($(this).attr('data-href')) {
     var parent = $(".countries_list_modal-content").attr('data-logged-in');
     var is_cart = $(".countries_list_modal-content").attr('data-cart-empty');
     const countryName = $(this).text();
     const listItem = $(this).parents('.countries_list_country-item');
     const flagIconClass = listItem.find('.countries_list_country-name span.flag-icon').attr('class');
    const linkHref = $(this).attr('v-href');              // Get the href attribute from the clicked link

    pushGa4CustomEvent('location', {
      country: countryName,
      page_location: window.location.href
    });

    if (maybeOpenCartMarketRedirectModal(linkHref)) {
       return;
     }

     localStorage.setItem('flagIconClass', flagIconClass);
     localStorage.setItem('selectedCountry', countryName);
     localStorage.setItem('selectedLinkHref', linkHref); // Save the href for later usage
     if (parent == "true" && is_cart == "false") {
       const parsedUrl = new URL(window.location.href);

       // Check if the path starts with `/en` and append it if present
       const baseUrlWithLang = parsedUrl.origin + (parsedUrl.pathname.startsWith('/en') ? '/en' : '');
       if (normalizeUrl(linkHref) !== normalizeUrl(baseUrlWithLang)) {
         document.querySelector('#country-change-modal').show();
       }


     } else {
       setTimeout(function () {
         window.location.href = linkHref;
       }, 300);
     }
   }
});
$(document).on("click",".countries_list_languages_url",function()
{
    // Set ManualCountryChange cookie for 1 minute with correct domain
    //const cookieDomain = location.hostname.includes('dev')
    //  ? '.dev.juiceplus.com'
    //  : '.juiceplus.com';
    //document.cookie = `ManualCountryChange=True; max-age=60; path=/; domain=${cookieDomain}; secure`;
    var parent = $(".countries_list_modal-content").attr('data-logged-in');
    var is_cart = $(".countries_list_modal-content").attr('data-cart-empty');
    const countryName = $(this).parents('.countries_list_country-item').find('.countries_list_url').text();
    const languageName = $(this).text();
    const listItem = $(this).parents('.countries_list_country-item');
    const flagIconClass = listItem.find('.countries_list_country-name span.flag-icon').attr('class');
    const linkHref = $(this).attr('v-href');              // Get the href attribute from the clicked link

    pushGa4CustomEvent('language', {
      language: languageName,
      country: countryName,
      page_location: window.location.href
    });
    
    if (maybeOpenCartMarketRedirectModal(linkHref)) {
      return;
    }

    localStorage.setItem('flagIconClass', flagIconClass);
    localStorage.setItem('selectedCountry', countryName);
    localStorage.setItem('selectedLanguage', languageName);
    localStorage.setItem('selectedLinkHref', linkHref); // Save the href for later usage
    if(parent=="true" && is_cart =="false")
    {
        const parsedUrl = new URL(window.location.href);

        // Check if the path starts with `/en` and append it if present
        const baseUrlWithLang = parsedUrl.origin + (parsedUrl.pathname.startsWith('/en') ? '/en' : '');
        console.log(baseUrlWithLang);
        if (normalizeUrl(linkHref) !== normalizeUrl(baseUrlWithLang)) {
          document.querySelector('#country-change-modal').show();
        }
        else
        {
          window.location.href = linkHref;
        }
    }
    else
    {
      setTimeout(function () {
        window.location.href = linkHref;
      }, 300);

    }
});
});

  window.clearCart = clearCart;
  window.openModal = openModal;
  window.closeCountryListModal = closeCountryListModal;
  window.setCurrentCountryLanguage = setCurrentCountryLanguage;
  window.setCountryAndLanguage = setCountryAndLanguage;
  window.setActiveState = setActiveState;
  window.normalizeUrl = normalizeUrl;
  window.trapFocus = trapFocus;
}
